import { WORKFLOW_ACTIONS } from 'modules/workflows/constants';
import { FbCustomAudienceNodeData } from 'modules/workflows/types';

const nodeActions = {
  [WORKFLOW_ACTIONS.ADD_USER_TO_FB]: 'Add to:',
  [WORKFLOW_ACTIONS.REMOVE_USER_FROM_FB]: 'Remove from:',
};

const isSetup = (nodeData: FbCustomAudienceNodeData): boolean => {
  return Boolean(nodeData?.adAccountId) && Boolean(nodeData?.customAudience);
};

const getTextSegments = (nodeData: FbCustomAudienceNodeData) => {
  const { nodeClass, customAudience } = nodeData;
  if (!customAudience) return;
  return {
    nodeDescBottom: {
      isTruncated: true,
      segments: [
        [{ text: nodeActions[nodeClass] }],
        [{ text: `“${customAudience?.customAudienceId} - ${customAudience?.name}”` }],
      ],
    },
  };
};

export default { isSetup, getTextSegments };
